import React, { useState, useEffect, useCallback } from "react";
import {
    Box, Stack, Typography, Paper, Button,
    CircularProgress, Chip, Avatar, IconButton,
    Drawer, Divider, Grid,
    // Composants pour le Tableau (ceux qui manquaient)
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
    // Composants pour le Dialog et Formulaire
    Dialog, DialogTitle, DialogContent, DialogActions,
    TextField, FormControl, InputLabel, Select, MenuItem, Breadcrumbs,
    Link as MuiLink, // On importe Link et on le renomme en MuiLink

} from "@mui/material";
import { Link } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";

// Icons
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import AddIcon from "@mui/icons-material/Add";
import VisibilityIcon from '@mui/icons-material/Visibility';
import CloseIcon from '@mui/icons-material/Close';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';

import AppSearch from "../../components/base/AppSearch";
import DeleteIcon from '@mui/icons-material/Delete';
import ConfirmDialog from "../../components/base/ConfirmDialog";
import AppPagination from "../../components/base/AppPagination";
import EditIcon from '@mui/icons-material/Edit';
const ClientsAbonnes = () => {
    const [searchTerm, setSearchTerm] = useState("");
    const [subscriptions, setSubscriptions] = useState([]);
    const [loading, setLoading] = useState(true);

    // État pour le Drawer de détails
    const [selectedSub, setSelectedSub] = useState(null);
    const [drawerOpen, setDrawerOpen] = useState(false);

    const apiUrl = process.env.REACT_APP_API_URL;
    const token = localStorage.getItem("token");
    const rolePath = "admin";

    const fetchSubscriptions = useCallback(async () => {
        try {
            setLoading(true);
            const response = await axios.get(`${apiUrl}/${rolePath}/subs/client_subscriptions/v/`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setSubscriptions(response.data.result || []);
        } catch (err) {
            console.error(err);
            toast.error("Erreur lors du chargement des abonnements");
        } finally {
            setLoading(false);
        }
    }, [apiUrl, token, rolePath]);

    useEffect(() => {
        fetchSubscriptions();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleOpenDetails = (sub) => {
        setSelectedSub(sub);
        setDrawerOpen(true);
    };




    // create client abonnés 

    const [openAddModal, setOpenAddModal] = useState(false);
    const [subscriptionsList, setSubscriptionsList] = useState([]); // Liste venant du back

    const [formData, setFormData] = useState({
        client_email: '',
        id_subs: '',
        date_expire_client_subs: '' // Nouveau champ
    });
    // 1. Charger les abonnements disponibles au montage du composant 
    useEffect(() => {
        const fetchSubs = async () => {
            try {
                const response = await axios.get(`${apiUrl}/${rolePath}/subs/g/get`, {
                    headers: { Authorization: `Bearer ${token}` }
                });

                // VERIFICATION : Axios encapsule tout dans .data
                // Si ton backend renvoie { status: 'success', result: [...] }
                if (response.data && response.data.result) {
                    setSubscriptionsList(response.data.result);
                } else if (Array.isArray(response.data)) {
                    // Au cas où ton backend renvoie directement le tableau
                    setSubscriptionsList(response.data);
                }
            } catch (error) {
                console.error("Erreur lors de la récupération des offres", error);
                toast.error("Impossible de charger les plans");
            }
        };

        if (token) fetchSubs();
    }, [apiUrl, rolePath, token]);

    const handleCreateSubscription = async () => {
        // 1. Validation simple avec toast
        if (!formData.client_email || !formData.id_subs) {
            toast.error("Veuillez remplir tous les champs");
            return;
        }

        setLoading(true);


        try {
            // 2. Envoi de la requête avec les headers (Token)
            await axios.post(
                `${apiUrl}/${rolePath}/subs/client-subscriptions/c`,
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                }
            );


            // Fermer la modal et réinitialiser le formulaire
            setOpenAddModal(false);
            setFormData({ client_email: '', id_subs: '' });

            // Rafraîchir la liste des abonnés
            fetchSubscriptions();

        } catch (error) {
            // 4. Gestion d'erreur avec toast
            console.error("Erreur création abonnement:", error);
        } finally {
            setLoading(false);
        }
    };

    // delete clients abonnées 
    // ... autres états
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [subToDelete, setSubToDelete] = useState(null);
    const [deleteLoading, setDeleteLoading] = useState(false);

    // Fonction pour ouvrir la confirmation
    const handleOpenDelete = (sub) => {
        setSubToDelete(sub);
        setConfirmOpen(true);
    };

    const handleDeleteSubscription = async () => {
        // 1. Log pour vérifier l'état au moment du clic
        console.log("Valeur de subToDelete au clic:", subToDelete);

        if (!subToDelete) {
            toast.error("Erreur de sélection : l'abonnement est introuvable.");
            return;
        }

        // TENTATIVE DE RÉCUPÉRATION DE L'ID
        // Vérifiez si c'est .id ou .id_client ou .id_user
        const clientId = subToDelete.id;

        if (!clientId) {
            console.error("Structure reçue complète:", subToDelete);
            toast.error("Impossible de récupérer l'ID du client.");
            return;
        }

        setDeleteLoading(true);
        try {
            const fullUrl = `${apiUrl}/${rolePath}/subs/client_subscriptions/d/${clientId}`;
            console.log("Appel API vers :", fullUrl);

            await axios.get(fullUrl, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            toast.success("client abonnés supprimé avec succès");
            setConfirmOpen(false);
            fetchSubscriptions();
        } catch (err) {
            console.error("Détails erreur 404:", err.response);
            toast.error(err.response?.data?.message || "La route API est introuvable (404)");
        } finally {
            setDeleteLoading(false);
            // On ne reset subToDelete QUE si la modal se ferme
        }
    };



    // pagination global
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 9; // Vous pouvez changer ce nombre
    // 1. On filtre ET on trie par ID décroissant (le plus récent en haut)
    const allFilteredAndSorted = subscriptions
        .filter(sub => {
            const clientName = `${sub.client?.nom_client} ${sub.client?.prenom_client}`.toLowerCase();
            const subsName = sub.subscription?.name_subs?.toLowerCase() || "";
            return clientName.includes(searchTerm.toLowerCase()) || subsName.includes(searchTerm.toLowerCase());
        })
        .sort((a, b) => b.id - a.id); // Tri décroissant

    // 2. On calcule les données à afficher pour la page actuelle
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = allFilteredAndSorted.slice(indexOfFirstItem, indexOfLastItem);


    // update clients abonnés 
    const [openEditModal, setOpenEditModal] = useState(false);
    const [subToEdit, setSubToEdit] = useState(null);
    const [editLoading, setEditLoading] = useState(false);

    // 1. Mets à jour l'état initial
    const [editFormData, setEditFormData] = useState({
        subs_client_subs: '', // Remplace id_subs par subs_client_subs
        status_client_subs: '',
        date_expire_client_subs: ''
    });

    // 2. Mets à jour la fonction d'ouverture
    const handleOpenEdit = (sub) => {
        setSubToEdit(sub);
        setEditFormData({
            subs_client_subs: sub.subs_client_subs, // Utilise le bon nom de colonne
            status_client_subs: sub.status_client_subs,
            date_expire_client_subs: sub.date_expire_client_subs || ''
        });
        setOpenEditModal(true);
    };
    const handleUpdateSubscription = async () => {
        setEditLoading(true);
        try {
            await axios.put(
                `${apiUrl}/${rolePath}/subs/client-subscriptions/u/${subToEdit.id}`,
                editFormData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                }
            );
            toast.success("Mise à jour réussie");
            setOpenEditModal(false);
            fetchSubscriptions();
        } catch (error) {
            toast.error("Erreur lors de la modification");
        } finally {
            setEditLoading(false);
        }
    };
    return (
        <Box sx={{ p: 3 }}>
            <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} sx={{ mb: 2 }}>
                <MuiLink component={Link} underline="hover" color="inherit" to="/clients">Clients</MuiLink>
                <Typography color="text.primary" sx={{ fontWeight: 600 }}>Clients Abonnés</Typography>
            </Breadcrumbs>

            <Stack direction={{ xs: "column", md: "row" }} justifyContent="space-between" alignItems="center" sx={{ mb: 6 }} spacing={2}>
                <Typography variant="h3" sx={{ fontWeight: "800", color: "#2B3674", fontSize: { xs: '1.8rem', md: '2.5rem' } }}>
                    Clients Abonnés
                </Typography>
                <Stack direction="row" spacing={2}>
                    <AppSearch value={searchTerm} onChange={setSearchTerm} placeholder="Rechercher..." />
                    <Button
                        variant="contained"
                        startIcon={<AddIcon />}
                        onClick={() => setOpenAddModal(true)} // Ajoute cette ligne
                     sx={{
                                bgcolor: "#4318FF",
                                borderRadius: "20px", // Plus arrondi pour l'effet "pilule"
                                px: 8,               // Réduit le padding (12 était trop large)
                                py: 1.5,             // Ajuste le padding vertical au lieu d'une hauteur fixe
                                textTransform: 'none',
                                fontSize: '14px',    // Taille de police standard dashboard
                                fontWeight: 600,     // Pour plus de lisibilité
                                whiteSpace: 'nowrap', // Force le texte sur une seule ligne
                                boxShadow: '0px 4px 12px rgba(67, 24, 255, 0.2)', // Optionnel: petite ombre portée
                                "&:hover": {
                                    bgcolor: "#3311CC",
                                    boxShadow: 'none'
                                }
                            }}
                    >
                        Ajouter un abonné
                    </Button>
                </Stack>
            </Stack>

            <Paper sx={{ p: 0, borderRadius: "20px", boxShadow: "0px 20px 50px rgba(112, 144, 176, 0.08)", overflow: "hidden" }}>
                {loading ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '300px' }}>
                        <CircularProgress sx={{ color: "#4318FF" }} />
                    </Box>
                ) : (
                    <TableContainer>
                        <Table sx={{ minWidth: 800 }}>
                            <TableHead sx={{ bgcolor: "#F4F7FE" }}>
                                <TableRow>
                                    <TableCell sx={{ color: "#A3AED0", fontWeight: "700" }}>CLIENT</TableCell>
                                    <TableCell sx={{ color: "#A3AED0", fontWeight: "700" }}>OFFRE</TableCell>
                                    <TableCell sx={{ color: "#A3AED0", fontWeight: "700" }}>PRIX</TableCell>
                                    <TableCell sx={{ color: "#A3AED0", fontWeight: "700" }}>RENOUVELLEMENT</TableCell>
                                    <TableCell sx={{ color: "#A3AED0", fontWeight: "700" }}>EXPIRATION</TableCell>
                                    <TableCell sx={{ color: "#A3AED0", fontWeight: "700" }}>STATUT</TableCell>
                                    <TableCell align="right" sx={{ color: "#A3AED0", fontWeight: "700" }}>ACTION</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {currentItems.map((row) => (
                                    <TableRow key={row.id} hover sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell>
                                            <Stack direction="row" alignItems="center" spacing={2}>
                                                <Avatar sx={{ bgcolor: "#E1E9FF", color: "#4318FF", fontWeight: 700 }}>
                                                    {row.client?.nom_client?.charAt(0).toUpperCase()}
                                                </Avatar>
                                                <Box>
                                                    <Typography variant="body2" sx={{ fontWeight: 700, color: "#2B3674" }}>
                                                        {row.client?.nom_client} {row.client?.prenom_client}
                                                    </Typography>
                                                    <Typography variant="caption" sx={{ color: "#A3AED0" }}>
                                                        {row.client?.email_client}
                                                    </Typography>
                                                </Box>
                                            </Stack>
                                        </TableCell>
                                        <TableCell>
                                            <Typography variant="body2" sx={{ color: "#2B3674", fontWeight: 600 }}>
                                                {row.subscription?.name_subs}
                                            </Typography>
                                        </TableCell>
                                        <TableCell>
                                            <Typography variant="body2" sx={{ color: "#2B3674", fontWeight: 700 }}>
                                                {row.price_client_subs} €
                                            </Typography>
                                        </TableCell>
                                        <TableCell sx={{ color: "#2B3674" }}>{row.date_renew_client_subs}</TableCell>
                                        <TableCell sx={{ color: "#EE5D50", fontWeight: 600 }}>{row.date_expire_client_subs}</TableCell>
                                        <TableCell>
                                            <Chip
                                                label={row.status_client_subs === "1" ? "Actif" : "Inactif"}
                                                size="small"
                                                sx={{ bgcolor: row.status_client_subs === "1" ? "#E6F9F0" : "#FFF5F5", color: row.status_client_subs === "1" ? "#05CD99" : "#EE5D50", fontWeight: 700, borderRadius: '8px' }}
                                            />
                                        </TableCell>
                                        <TableCell align="right">
                                            <IconButton onClick={() => handleOpenDetails(row)} sx={{ color: "#4318FF" }}>
                                                <VisibilityIcon fontSize="small" />
                                            </IconButton>
                                            {/* NOUVELLE ICÔNE : MODIFIER */}
                                            <IconButton
                                                onClick={() => handleOpenEdit(row)}
                                                sx={{
                                                    color: "#4318FF",
                                                    mx: 1, // Ajoute un petit espace horizontal
                                                    '&:hover': { backgroundColor: "rgba(67, 24, 255, 0.1)" }
                                                }}
                                            >
                                                <EditIcon fontSize="small" />
                                            </IconButton>
                                            <IconButton
                                                onClick={() => handleOpenDelete(row)}
                                                sx={{
                                                    color: "#EE5D50",
                                                    "&:hover": { bgcolor: "#FFF5F5" }
                                                }}
                                            >
                                                <DeleteIcon fontSize="small" />
                                            </IconButton>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>

                )}
                <AppPagination
                    count={Math.ceil(allFilteredAndSorted.length / itemsPerPage)}
                    page={currentPage}
                    onChange={(e, value) => setCurrentPage(value)}
                    totalItems={allFilteredAndSorted.length}
                    itemsPerPage={itemsPerPage}
                />
            </Paper>

            {/* DRAWER DE DÉTAILS PROFESSIONNEL */}
            <Drawer
                anchor="right"
                open={drawerOpen}
                onClose={() => setDrawerOpen(false)}
                sx={{ zIndex: 3000 }}
                PaperProps={{
                    sx: {
                        width: { xs: '100%', sm: 550 },
                        p: 0, // On gère le padding à l'intérieur pour le design
                        borderLeft: "1px solid #E0E5F2"
                    }
                }}
            >
                {selectedSub && (
                    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>

                        {/* 1. Header Profil & Background */}
                        <Box sx={{ p: 3, background: "linear-gradient(135deg, #4318FF 0%, #3311CC 100%)", color: "white", position: 'relative' }}>
                            <IconButton
                                onClick={() => setDrawerOpen(false)}
                                sx={{ position: 'absolute', right: 8, top: 8, color: "white" }}
                            >
                                <CloseIcon />
                            </IconButton>

                            <Stack spacing={2} alignItems="center" sx={{ mt: 2 }}>
                                <Avatar
                                    src={`${apiUrl.replace('/api', '')}/${selectedSub.subscription?.photo_subs}`}
                                    sx={{ width: 80, height: 80, border: "4px solid rgba(255,255,255,0.2)", bgcolor: "white", color: "#4318FF", fontSize: "2rem", fontWeight: 800 }}
                                >
                                    {selectedSub.client?.nom_client[0]}
                                </Avatar>
                                <Box sx={{ textAlign: 'center' }}>
                                    <Typography variant="h5" sx={{ fontWeight: 800 }}>
                                        {selectedSub.client?.nom_client} {selectedSub.client?.prenom_client}
                                    </Typography>
                                    <Typography variant="body2" sx={{ opacity: 0.8 }}>
                                        {selectedSub.client?.email_client} • ID: #{selectedSub.client?.id_client}
                                    </Typography>
                                    <Chip
                                        label={selectedSub.status_client_subs === "1" ? "Abonnement Actif" : "Inactif"}
                                        sx={{ mt: 1, bgcolor: "rgba(255,255,255,0.2)", color: "white", fontWeight: 700, backdropFilter: "blur(10px)" }}
                                    />
                                </Box>
                            </Stack>
                        </Box>

                        <Box sx={{ p: 3, flexGrow: 1, overflowY: 'auto' }}>

                            {/* 2. Section: Détails de l'Offre */}
                            <Typography variant="subtitle2" sx={{ color: "#A3AED0", fontWeight: 700, textTransform: "uppercase", mb: 2, letterSpacing: 1 }}>
                                Plan de Souscription
                            </Typography>
                            <Paper variant="outlined" sx={{ p: 2, borderRadius: "16px", mb: 4, borderColor: "#E0E5F2" }}>
                                <Stack direction="row" justifyContent="space-between" alignItems="center">
                                    <Box>
                                        <Typography variant="h6" sx={{ color: "#2B3674", fontWeight: 800 }}>
                                            {selectedSub.subscription?.name_subs}
                                        </Typography>
                                        <Typography variant="caption" color="textSecondary">
                                            Intervalle: {selectedSub.subscription?.interval_subs === 'month' ? 'Mensuel' : 'Annuel'}
                                        </Typography>
                                    </Box>
                                    <Typography variant="h5" sx={{ color: "#4318FF", fontWeight: 800 }}>
                                        {selectedSub.price_client_subs} €
                                    </Typography>
                                </Stack>
                                <Divider sx={{ my: 2 }} />
                                <Typography variant="body2" sx={{ color: "#707EAE", fontStyle: 'italic' }}>
                                    "{selectedSub.subscription?.description_subs}"
                                </Typography>
                            </Paper>

                            {/* 3. Section: Timeline des Dates */}
                            <Typography variant="subtitle2" sx={{ color: "#A3AED0", fontWeight: 700, textTransform: "uppercase", mb: 2 }}>
                                Dates Clés
                            </Typography>
                            <Stack spacing={2} sx={{ mb: 4 }}>
                                {[
                                    { label: "Date d'achat", date: selectedSub.date_buy_client_subs, icon: <CalendarMonthIcon sx={{ color: "#05CD99" }} /> },
                                    { label: "Dernier renouvellement", date: selectedSub.date_renew_client_subs, icon: <CalendarMonthIcon sx={{ color: "#4318FF" }} /> },
                                    { label: "Date d'expiration", date: selectedSub.date_expire_client_subs, icon: <CalendarMonthIcon sx={{ color: "#EE5D50" }} />, bold: true },
                                ].map((item, index) => (
                                    <Stack key={index} direction="row" alignItems="center" justifyContent="space-between" sx={{ p: 1.5, bgcolor: "#F4F7FE", borderRadius: "12px" }}>
                                        <Stack direction="row" spacing={2} alignItems="center">
                                            {item.icon}
                                            <Typography variant="body2" sx={{ color: "#2B3674", fontWeight: 600 }}>{item.label}</Typography>
                                        </Stack>
                                        <Typography variant="body2" sx={{ fontWeight: item.bold ? 800 : 500, color: item.bold ? "#EE5D50" : "#2B3674" }}>
                                            {item.date}
                                        </Typography>
                                    </Stack>
                                ))}
                            </Stack>

                            {/* 4. Section: Compteurs de Ressources (Grille) */}
                            <Typography variant="subtitle2" sx={{ color: "#A3AED0", fontWeight: 700, textTransform: "uppercase", mb: 2 }}>
                                Utilisation des Ressources
                            </Typography>
                            <Grid container spacing={2} sx={{ mb: 4 }}>
                                {[
                                    { label: "Workshops", value: selectedSub.nbr_workshops, total: selectedSub.subscription?.nbr_workshops },
                                    { label: "Vidéos", value: selectedSub.nbr_video, total: selectedSub.subscription?.nbr_video },
                                    { label: "Offres", value: selectedSub.nbr_offre, total: selectedSub.subscription?.nbr_offre },
                                ].map((res, i) => (
                                    <Grid size={4} key={i}>
                                        <Paper sx={{ textAlign: 'center', p: 2, borderRadius: "16px", border: "1px solid #E0E5F2", boxShadow: "none" }}>
                                            <Typography variant="h5" sx={{ color: "#4318FF", fontWeight: 800 }}>{res.value}</Typography>
                                            <Typography variant="caption" sx={{ color: "#A3AED0", display: 'block' }}>{res.label}</Typography>
                                            <Typography variant="caption" sx={{ fontSize: '10px', color: '#707EAE' }}>Quota: {res.total}</Typography>
                                        </Paper>
                                    </Grid>
                                ))}
                            </Grid>

                            {/* 5. Section: Informations Techniques (Stripe/Metadata) */}
                            <Typography variant="subtitle2" sx={{ color: "#A3AED0", fontWeight: 700, textTransform: "uppercase", mb: 2 }}>
                                Données Techniques
                            </Typography>
                            <Box sx={{ p: 2, bgcolor: "#F4F7FE", borderRadius: "16px" }}>
                                <Stack spacing={1.5}>
                                    <Box>
                                        <Typography variant="caption" color="textSecondary">ID Stripe</Typography>
                                        <Typography variant="body2" sx={{ fontWeight: 600, wordBreak: 'break-all' }}>{selectedSub.stripe_client_subs || "N/A"}</Typography>
                                    </Box>
                                    <Box>
                                        <Typography variant="caption" color="textSecondary">Créé le</Typography>
                                        <Typography variant="body2" sx={{ fontWeight: 600 }}>{new Date(selectedSub.created_at).toLocaleString('fr-FR')}</Typography>
                                    </Box>
                                    <Box>
                                        <Typography variant="caption" color="textSecondary">Dernière mise à jour</Typography>
                                        <Typography variant="body2" sx={{ fontWeight: 600 }}>{new Date(selectedSub.updated_at).toLocaleString('fr-FR')}</Typography>
                                    </Box>
                                </Stack>
                            </Box>
                        </Box>

                        {/* Pied de page du Drawer */}
                        <Box sx={{ p: 3, borderTop: "1px solid #E0E5F2", bgcolor: "#FAFBFF" }}>
                            <Button
                                fullWidth
                                variant="contained"
                                onClick={() => setDrawerOpen(false)}
                                sx={{ bgcolor: "#4318FF", borderRadius: "12px", py: 1.5, textTransform: 'none', fontWeight: 700 }}
                            >
                                Fermer les détails
                            </Button>
                        </Box>
                    </Box>
                )}
            </Drawer>

            <Dialog
                open={openAddModal}
                onClose={() => !loading && setOpenAddModal(false)}
                fullWidth
                maxWidth="xs"
                PaperProps={{ sx: { borderRadius: "20px", p: 1 } }}
            >
                <DialogTitle sx={{ fontWeight: 800, color: "#2B3674" }}>
                    Attribuer un abonnement
                </DialogTitle>

                <DialogContent>
                    <Stack spacing={3} sx={{ mt: 1 }}>
                        <Typography variant="body2" color="textSecondary">
                            Saisissez l'adresse email d'un client existant pour lui activer un plan manuellement.
                        </Typography>

                        {/* Champ Email Client */}
                        <TextField
                            fullWidth
                            label="Email du client"
                            variant="outlined"
                            placeholder="exemple@email.com"
                            value={formData.client_email}
                            onChange={(e) => setFormData({ ...formData, client_email: e.target.value })}
                            sx={{ "& .MuiOutlinedInput-root": { borderRadius: "12px" } }}
                        />

                        {/* 1. FormControl dédié UNIQUEMENT au Select */}
                        <FormControl fullWidth sx={{ "& .MuiOutlinedInput-root": { borderRadius: "12px" } }}>
                            <InputLabel id="select-plan-label">Plan d'abonnement</InputLabel>
                            <Select
                                labelId="select-plan-label"
                                id="select-plan"
                                label="Plan d'abonnement" // Important pour que le contour s'adapte au label
                                value={formData.id_subs}
                                onChange={(e) => setFormData({ ...formData, id_subs: e.target.value })}
                            >
                                <MenuItem value="" disabled>
                                    <em>Sélectionnez un plan</em>
                                </MenuItem>

                                {subscriptionsList && subscriptionsList.length > 0 ? (
                                    subscriptionsList.map((sub) => (
                                        <MenuItem key={sub.id_subs} value={sub.id_subs}>
                                            <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ width: '100%' }}>
                                                <Typography sx={{ fontWeight: 600 }}>{sub.name_subs}</Typography>
                                                <Chip
                                                    label={`${sub.price_subs} €`}
                                                    size="small"
                                                    sx={{ ml: 2, bgcolor: "#E1E9FF", color: "#4318FF", fontWeight: 700 }}
                                                />
                                            </Stack>
                                        </MenuItem>
                                    ))
                                ) : (
                                    <MenuItem disabled value="">
                                        <Typography variant="body2">Aucun plan disponible</Typography>
                                    </MenuItem>
                                )}
                            </Select>
                        </FormControl>

                        {/* 2. TextField Date d'expiration SORTI du FormControl précédent */}
                        <TextField
                            fullWidth
                            label="Date d'expiration (Optionnelle)"
                            type="date"
                            variant="outlined"
                            InputLabelProps={{ shrink: true }}
                            value={formData.date_expire_client_subs}
                            onChange={(e) => setFormData({ ...formData, date_expire_client_subs: e.target.value })}
                            helperText="Laissez vide pour calculer automatiquement 1 an."
                            sx={{
                                "& .MuiOutlinedInput-root": { borderRadius: "12px" },
                                "& .MuiFormHelperText-root": { color: "#A3AED0", fontStyle: 'italic' }
                            }}
                        />
                    </Stack>
                </DialogContent>

                <DialogActions sx={{ p: 3 }}>
                    <Button
                        onClick={() => setOpenAddModal(false)}
                        disabled={loading}
                        sx={{ color: "#707EAE", textTransform: 'none', fontWeight: 600 }}
                    >
                        Annuler
                    </Button>
                    <Button
                        variant="contained"
                        onClick={handleCreateSubscription}
                        disabled={loading}
                        startIcon={loading ? <CircularProgress size={20} color="inherit" /> : null}
                        sx={{
                            bgcolor: "#4318FF",
                            borderRadius: "12px",
                            px: 4,
                            textTransform: 'none',
                            fontWeight: 700,
                            "&:hover": { bgcolor: "#3311CC" }
                        }}
                    >
                        {loading ? "Création..." : "Confirmer l'activation"}
                    </Button>
                </DialogActions>
            </Dialog>

            <ConfirmDialog
                open={confirmOpen}
                onClose={() => !deleteLoading && setConfirmOpen(false)}
                onConfirm={handleDeleteSubscription}
                title="Supprimer l'abonnement"
                message={`Êtes-vous sûr de vouloir supprimer l'abonnement de ${subToDelete?.client?.nom_client} ? Cette action est irréversible.`}
                loading={deleteLoading}
            />

            <Dialog
                open={openEditModal}
                onClose={() => !editLoading && setOpenEditModal(false)}
                fullWidth
                maxWidth="xs"
            >
                <DialogTitle sx={{ fontWeight: 800, color: "#2B3674", textAlign: 'center' }}>
                    Modifier l'Abonnement
                </DialogTitle>

                <DialogContent>
                    <Box sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 3 }}>

                        {/* 1. Sélection du Plan (CORRIGÉ) */}
                        <FormControl fullWidth>
                            <InputLabel>Type de Plan</InputLabel>
                            <Select
                                value={editFormData.subs_client_subs} // Utilise subs_client_subs
                                label="Type de Plan"
                                onChange={(e) => setEditFormData({ ...editFormData, subs_client_subs: e.target.value })}
                            >
                                {subscriptionsList.map((sub) => (
                                    <MenuItem key={sub.id_subs} value={sub.id_subs}>
                                        {sub.name_subs}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>

                        {/* 2. Statut (CORRIGÉ) */}
                        <FormControl fullWidth>
                            <InputLabel>Statut du compte</InputLabel>
                            <Select
                                value={editFormData.status_client_subs} // Utilise status_client_subs
                                label="Statut du compte"
                                onChange={(e) => setEditFormData({ ...editFormData, status_client_subs: e.target.value })}
                            >
                                <MenuItem value="1">Actif</MenuItem>
                                <MenuItem value="0">Inactif</MenuItem>
                            </Select>
                        </FormControl>

                        {/* 3. Date d'expiration */}
                        <TextField
                            fullWidth
                            label="Date d'expiration"
                            type="date"
                            InputLabelProps={{ shrink: true }}
                            value={editFormData.date_expire_client_subs}
                            onChange={(e) => setEditFormData({ ...editFormData, date_expire_client_subs: e.target.value })}
                        />
                    </Box>
                </DialogContent>

                <DialogActions sx={{ p: 3, justifyContent: 'center' }}>
                    <Button onClick={() => setOpenEditModal(false)} sx={{ color: "#707EAE" }}>
                        Annuler
                    </Button>
                    <Button
                        variant="contained"
                        onClick={handleUpdateSubscription}
                        disabled={editLoading}
                        sx={{ bgcolor: "#4318FF", borderRadius: "12px", px: 4 }}
                    >
                        {editLoading ? <CircularProgress size={24} color="inherit" /> : "Mettre à jour"}
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
};

export default ClientsAbonnes;